const prodEnv = process.env.NEXT_PUBLIC_API_URL_PROD;
const devEnv = process.env.NEXT_PUBLIC_API_URL_DEV;
const variantEnv = process.env.NEXT_PUBLIC_BACKEND_VARIANT;

function stripTrailingSlash(s: string) {
  return s.replace(/\s+$/g, "").replace(/\/+$/, "");
}

function deriveWsUrl(httpUrl: string) {
  if (!httpUrl) return "";
  if (httpUrl.startsWith("https://")) return httpUrl.replace(/^https:/, "wss:");
  if (httpUrl.startsWith("http://")) return httpUrl.replace(/^http:/, "ws:");
  return "";
}

let chosenRaw: string = "";
const defaultVariant = process.env.NODE_ENV === "production" ? "prod" : "dev";
const variant = (variantEnv ?? defaultVariant).toLowerCase();

if (variant === "prod") {
  chosenRaw = prodEnv ?? "";
} else if (variant === "dev") {
  chosenRaw = devEnv ?? "";
}

if (!chosenRaw) {
  if (typeof window === "undefined") {
    console.warn(
      "NEXT_PUBLIC_API_URL_PROD (or NEXT_PUBLIC_API_URL_DEV) not set. API_URL will be empty.",
    );
  } else {
    console.error(
      "NEXT_PUBLIC_API_URL_PROD (or NEXT_PUBLIC_API_URL_DEV) not set. Please set it in your environment.",
    );
  }
}

export const API_URL = stripTrailingSlash(chosenRaw);
export const WS_API_URL = deriveWsUrl(API_URL);
